<template>
  <b-modal
    title="Selection de template"
    :modal-class="'base-modal'"
    centered
    ref="templateSelectionModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <b-container fluid>
      <loading class="small" v-if="isLoadingTemplatesFiche()" />
      <div
        v-else-if="!isLoadingTemplatesFiche() && templates"
        class="text-edit"
      >
        <template v-if="hasTemplates">
          <h2 class="sub-title">Choix du template</h2>
          <p class="info">
            Veuillez choisir le template à appliquer à votre fiche d'espaces.
          </p>
          <b-form-select v-model="selected" class="mb-3">
            <template slot="first">
              <option :value="null" disabled>-- Choix de template --</option>
            </template>
            <!-- <template v-for="onglet in this.ongletList"> -->
            <option
              v-for="fiche in templates[this.tableauTemplateId()]"
              :key="'fiche-' + fiche.id"
              :value="{ id: fiche.id }"
              >{{ fiche.nom }}</option
            >
            <!-- </template> -->
          </b-form-select>
        </template>
        <template v-else>
          <h2 class="sub-title">Choix du template</h2>
          <p class="info text-info">
            Vous ne pouvez actuellement pas appliquer de template, parce que:
          </p>
          <ul class="list-info">
            <li>
              Votre tableau de surface ne dispose pas d'une structure de données
              issu d'un template.
            </li>
            <li>
              Vous n'avez actuellement pas de templates de fiche d'espaces.
            </li>
          </ul>
          <b-alert show
            ><font-awesome-icon :icon="['fas', 'info-circle']" /> Cliquez
            <b-link :to="`/templates-fiches/${templateId()}`">içi</b-link> pour
            en créer.</b-alert
          >
        </template>
      </div>
    </b-container>

    <div v-if="!isLoadingTemplatesFiche()" slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button variant="primary" size="md" @click="applyTemplate">
          Appliquer
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import iconBase from '../../icons/iconBase'
import loading from '../../loading'
import { mapGetters } from 'vuex'
export default {
  components: {
    iconBase,
    loading
  },
  computed: {
    ongletList () {
      return this.templates ? Object.keys(this.templates) : []
    },
    hasTemplates () {
      if (!this.ongletList.length) {
        return false
      }

      /* const num = this.ongletList.map(el => {
        return this.templates[el].length
      }).reduce((prev, curr) => {
        return prev + curr
      })
      if (!num) {
        return false
      } */

      if (!this.tableauTemplateId() || !this.templates[this.tableauTemplateId()] || !this.templates[this.tableauTemplateId()].length) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      templates: null,
      selected: null
    }
  },
  methods: {
    ...mapGetters(['isLoadingTemplatesFiche', 'templateId', 'tableauTemplateId']),
    close () {
      this.$refs['templateSelectionModal'].hide()
    },
    open (templates) {
      if (!this.templates) {
        this.templates = templates
      }
      this.$refs['templateSelectionModal'].show()
    },
    applyTemplate () {
      if (this.selected) {
        this.$emit('apply', { ...this.selected })
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.small {
  position: relative;
}
.text-edit {
  margin-top: 20px;
  width: 100%;
  p.info {
    font-style: italic;
    color: rgba(0, 0, 0, 0.5);
    font-size: 13px;
    text-align: left;
  }
  .list-info {
    font-size: 13px;
  }
  h2.sub-title {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/selectionStructure.vue